import { BinScatterMultiSelectResult } from 'libs/end-to-end/src/bin-scatter';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';

export const BinScatterMultiSelectCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'binScatterMultiSelect',
  isDataQueuingAllowed: true,
  outputFileName: 'binscatter_multi_select_result.json',
  outputSchema: BinScatterMultiSelectResult,
  resolveFocusArea: (request) => {
    if (request.customVizId !== 'binScatterMultiSelect') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.focusArea;
  },
  resolveFilters: (request) => {
    if (request.customVizId !== 'binScatterMultiSelect') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.443,
    multiplier: 0.0692,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'binScatterMultiSelect') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [request.inputs.extras.focusArea],
    };
  },
  getUrlPath: (focusArea) => `${focusArea}/group-trends`,
};
